module.exports = __webpack_public_path__ + "static/media/hilda_s_dt_by_corriger-dasn7q4.7931f82c.png";